import React, { useState, useEffect } from "react";

const links = [
  { label: "About", href: "#about" },
  { label: "Work", href: "#work" },
  { label: "Skills", href: "#skills" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [clock, setClock] = useState("--:--:--");

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      setProgress(total > 0 ? (h.scrollTop / total) * 100 : 0);
      setScrolled(h.scrollTop > 40);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const tick = () => {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      setClock(`${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: scrolled ? "rgba(5,7,13,0.72)" : "transparent",
        backdropFilter: scrolled ? "blur(12px) saturate(140%)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(12px) saturate(140%)" : "none",
        borderBottom: scrolled ? "1px solid var(--line)" : "1px solid transparent",
        transition: "background 0.4s ease, border-color 0.4s ease",
      }}
    >
      <nav
        style={{
          maxWidth: "var(--maxw)",
          margin: "0 auto",
          padding: "14px clamp(20px, 5vw, 48px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
        }}
      >
        <a
          href="#top"
          style={{
            fontFamily: "var(--display)",
            fontWeight: 700,
            fontSize: "1.05rem",
            letterSpacing: "0.04em",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <span
            style={{
              display: "inline-grid",
              placeItems: "center",
              width: "34px",
              height: "34px",
              border: "1px solid var(--cyan)",
              color: "var(--cyan)",
              fontSize: "0.9rem",
              boxShadow: "0 0 12px rgba(52,224,255,0.4), inset 0 0 12px rgba(52,224,255,0.15)",
              clipPath: "polygon(0 0, 100% 0, 100% 70%, 70% 100%, 0 100%)",
            }}
          >
            JR
          </span>
          <span className="glow-text" style={{ color: "var(--text)" }}>
            RAJALAHTI
            <span style={{ color: "var(--cyan)" }}>_</span>
          </span>
        </a>

        {/* Desktop links */}
        <ul
          className="nav-desktop"
          style={{
            listStyle: "none",
            display: "flex",
            gap: "30px",
            alignItems: "center",
          }}
        >
          {links.map((l, i) => (
            <li key={l.href}>
              <a
                href={l.href}
                style={{
                  textDecoration: "none",
                  fontFamily: "var(--mono)",
                  fontSize: "0.74rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.12em",
                  color: "var(--text-soft)",
                  display: "inline-flex",
                  gap: "6px",
                  transition: "color 0.25s ease, text-shadow 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "var(--cyan)";
                  e.currentTarget.style.textShadow = "0 0 12px var(--glow)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "var(--text-soft)";
                  e.currentTarget.style.textShadow = "none";
                }}
              >
                <span style={{ color: "var(--cyan)" }}>{`0${i + 1}`}</span>
                {l.label}
              </a>
            </li>
          ))}
          <li
            className="nav-clock"
            style={{
              fontFamily: "var(--mono)",
              fontSize: "0.72rem",
              color: "var(--cyan)",
              border: "1px solid var(--line)",
              padding: "5px 10px",
              letterSpacing: "0.08em",
            }}
          >
            <span style={{ color: "var(--text-faint)" }}>EET </span>
            {clock}
          </li>
        </ul>

        {/* Mobile toggle */}
        <button
          className="nav-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((o) => !o)}
          style={{
            display: "none",
            background: "transparent",
            color: "var(--cyan)",
            border: "1px solid var(--line-strong)",
            width: "44px",
            height: "44px",
            cursor: "pointer",
            fontSize: "1.1rem",
          }}
        >
          {open ? "✕" : "☰"}
        </button>
      </nav>

      {/* Mobile dropdown */}
      <div
        className="nav-mobile"
        style={{
          display: "none",
          overflow: "hidden",
          maxHeight: open ? "360px" : "0",
          transition: "max-height 0.4s var(--ease)",
          background: "rgba(8,11,20,0.96)",
          borderBottom: open ? "1px solid var(--line)" : "none",
        }}
      >
        <ul style={{ listStyle: "none", padding: "8px clamp(20px,5vw,48px) 24px" }}>
          {links.map((l, i) => (
            <li key={l.href} style={{ borderTop: "1px solid var(--line)" }}>
              <a
                href={l.href}
                onClick={() => setOpen(false)}
                style={{
                  textDecoration: "none",
                  display: "flex",
                  gap: "14px",
                  alignItems: "center",
                  padding: "16px 0",
                  fontFamily: "var(--display)",
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  color: "var(--text)",
                }}
              >
                <span style={{ fontFamily: "var(--mono)", fontSize: "0.8rem", color: "var(--cyan)" }}>
                  {`0${i + 1}`}
                </span>
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Scroll progress */}
      <div style={{ position: "relative", height: "2px", background: "rgba(52,224,255,0.12)" }}>
        <div
          style={{
            height: "100%",
            background: "linear-gradient(90deg, var(--cyan-deep), var(--cyan))",
            width: `${progress}%`,
            boxShadow: "0 0 10px var(--glow)",
            transition: "width 0.1s linear",
          }}
        />
      </div>

      <style>{`
        @media (max-width: 820px) {
          .nav-clock { display: none !important; }
        }
        @media (max-width: 760px) {
          .nav-desktop { display: none !important; }
          .nav-toggle { display: block !important; }
          .nav-mobile { display: block !important; }
        }
      `}</style>
    </header>
  );
}
